"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildFileSchema = void 0;
const tslib_1 = require("tslib");
const fluent_json_schema_1 = tslib_1.__importDefault(require("fluent-json-schema"));
const buildFileMetadataSchema_1 = require("./buildFileMetadataSchema");
const contentTypeSchema_1 = require("./contentTypeSchema");
const extensionSchema_1 = require("./extensionSchema");
const fileTypeSchema_1 = require("./fileTypeSchema");
const buildFileSchema = (fileMetadataSchema) => {
    const fileMetadataPropSchema = (0, buildFileMetadataSchema_1.buildFileMetadataSchema)(fileMetadataSchema);
    const objectSchema = fluent_json_schema_1.default.object()
        .prop(fileTypeSchema_1.fileTypeSchema.prop, fileTypeSchema_1.fileTypeSchema.schema)
        .prop(extensionSchema_1.extensionSchema.prop, extensionSchema_1.extensionSchema.schema)
        .prop(contentTypeSchema_1.contentTypeSchema.prop, contentTypeSchema_1.contentTypeSchema.schema)
        .prop(fileMetadataPropSchema.prop, fileMetadataPropSchema.schema);
    return objectSchema;
};
exports.buildFileSchema = buildFileSchema;
//# sourceMappingURL=buildFileSchema.js.map